module.exports = __webpack_public_path__ + "static/media/modifierGroup.9044f43a.svg";